<script lang="ts">
  import { page } from '@inertiajs/svelte'
  import type { Snippet } from 'svelte'
  import type { WhatsNew } from '@/types'
  import Navbar from './Navbar.svelte'
  import MobileHeader from './MobileHeader.svelte'
  import MobileBottomNav from './MobileBottomNav.svelte'
  import WhatsNewCard from './WhatsNewCard.svelte'

  let {
    children,
    showWhatsNewBanner = true,
  }: { children: Snippet; showWhatsNewBanner?: boolean } = $props()
  let whatsNew = $derived(page.props.whats_new as WhatsNew | undefined)
</script>

<div class="app-layout" class:mobile-app-shell={!!page.props.current_user}>
  <MobileHeader />
  <Navbar />

  <div class="app-content" {...{ 'scroll-region': '' }}>
    {#if whatsNew && showWhatsNewBanner}
      <div class="bg-neutral-50 px-4 pt-4 dark:bg-gray-900">
        <div class="mx-auto max-w-6xl">
          <WhatsNewCard
            latest={whatsNew.latest}
            missedCount={whatsNew.missed_count}
            acknowledgeThrough={whatsNew.acknowledge_through}
            acknowledgePath={whatsNew.acknowledge_path}
            changelogPath={whatsNew.changelog_path}
            compact={true}
          />
        </div>
      </div>
    {/if}

    {@render children()}
  </div>

  <MobileBottomNav />
</div>

<!--
  Note: For consistent page layouts, wrap your content in PageContainer:
  <PageContainer>...</PageContainer>

  This provides the standard max-w-6xl container with proper spacing.
  For custom layouts (landing pages, full-width grids), skip PageContainer.
-->

<style>
  .app-layout,
  .app-content {
    display: contents;
  }

  @media (width < 48rem) {
    /* Keep app chrome out of the document scroller: iOS standalone apps
       can paint fixed/sticky navigation away from the viewport edge. */
    .mobile-app-shell {
      display: flex;
      flex-direction: column;
      height: 100vh;
      height: 100dvh;
      overflow: clip;
    }

    .mobile-app-shell > .app-content {
      display: block;
      position: relative;
      flex: 1;
      min-height: 0;
      overflow-y: auto;
      overscroll-behavior-y: contain;
    }
  }
</style>
